import { BusinessTemplate } from "@/features/previews/templates/business";
import { VcardTemplate } from "@/features/previews/templates/vcard";
import { EventTemplate } from "@/features/previews/templates/event";
import { FeedbackTemplate } from "@/features/previews/templates/feedback";
import { SocialTemplate } from "@/features/previews/templates/social";
import { VideoTemplate } from "@/features/previews/templates/video";
import { AppsTemplate } from "@/features/previews/templates/apps";
import { PdfTemplate } from "@/features/previews/templates/pdf";
import { UrlTemplate } from "@/features/previews/templates/url";
import { ImagesTemplate } from "@/features/previews/templates/images";
import { EmptyPreview } from "@/features/previews/templates/empty";
import { YoutubeTemplate } from "@/features/previews/templates/youtube";
import { ListLinksTemplate } from "@/features/previews/templates/list-links";
import { WebsiteTemplate } from "@/features/previews/templates/website";
import { CouponTemplate } from "@/features/previews/templates/coupon";
import { Mp3Template } from "@/features/previews/templates/mp3";
import { TextTemplate } from "@/features/previews/templates/text";
import { SmsTemplate } from "@/features/previews/templates/sms";
import { EmailTemplate } from "@/features/previews/templates/email";
import { WhatsappTemplate } from "@/features/previews/templates/whatsapp";
import { WifiTemplate } from "@/features/previews/templates/wifi";

import { previewRegistry } from "./PreviewRegistry";
import { QRProps } from "../types";

let initialized = false;

// Registers every legacy preview component under the same keys as `data.type`.
export const initializePreviewRegistry = (): void => {
  if (initialized) {
    return;
  }
  initialized = true;

  previewRegistry.register(
    "empty" as any,
    EmptyPreview,
    () =>
      import("@/features/previews/templates/empty/initPreviewEmptyData.json") as unknown as Promise<
        QRProps<any>
      >
  );

  previewRegistry.register(
    "apps",
    AppsTemplate,
    () =>
      import("@/features/previews/templates/apps/initPreviewAppsData.json") as unknown as Promise<
        QRProps<"apps">
      >
  );

  previewRegistry.register(
    "business",
    BusinessTemplate,
    () =>
      import("@/features/previews/templates/business/initPreviewBusinessData.json") as unknown as Promise<
        QRProps<"business">
      >
  );

  previewRegistry.register(
    "vcard",
    VcardTemplate,
    () =>
      import("@/features/previews/templates/vcard/initPreviewVcardData.json") as unknown as Promise<
        QRProps<"vcard">
      >
  );

  previewRegistry.register(
    "pdf",
    PdfTemplate,
    () =>
      import("@/features/previews/templates/pdf/initPreviewData.json") as unknown as Promise<
        QRProps<"pdf">
      >
  );

  previewRegistry.register(
    "feedback",
    FeedbackTemplate,
    () =>
      import("@/features/previews/templates/feedback/initPreviewFeedbackData.json") as unknown as Promise<
        QRProps<"feedback">
      >
  );

  previewRegistry.register(
    "listoflinks",
    ListLinksTemplate,
    () =>
      import("@/features/previews/templates/list-links/initPreviewListLinksData.json") as unknown as Promise<
        QRProps<"listoflinks">
      >
  );

  previewRegistry.register(
    "url",
    UrlTemplate,
    () =>
      import("@/features/previews/templates/url/initPreviewUrlData.json") as unknown as Promise<
        QRProps<"url">
      >
  );

  previewRegistry.register(
    "url-static",
    UrlTemplate,
    () =>
      import("@/features/previews/templates/url/initPreviewUrlStaticData.json") as unknown as Promise<
        QRProps<"url-static">
      >
  );

  previewRegistry.register(
    "image",
    ImagesTemplate,
    () =>
      import("@/features/previews/templates/images/initPreviewImagesData.json") as unknown as Promise<
        QRProps<"image">
      >
  );

  previewRegistry.register(
    "listoflinks",
    ListLinksTemplate,
    () =>
      import("@/features/previews/templates/list-links/initPreviewListLinksData.json") as unknown as Promise<
        QRProps<"listoflinks">
      >
  );

  previewRegistry.register(
    "website",
    WebsiteTemplate,
    () =>
      import("@/features/previews/templates/website/initPreviewWebsiteData.json") as unknown as Promise<
        QRProps<"website">
      >
  );

  previewRegistry.register(
    "coupon",
    CouponTemplate,
    () =>
      import("@/features/previews/templates/coupon/initPreviewCouponData.json") as unknown as Promise<
        QRProps<"coupon">
      >
  );

  previewRegistry.register(
    "youtube",
    YoutubeTemplate,
    () =>
      import("@/features/previews/templates/youtube/initPreviewYoutubeData.json") as unknown as Promise<
        QRProps<"youtube">
      >
  );

  previewRegistry.register(
    "mp3",
    Mp3Template,
    () =>
      import("@/features/previews/templates/mp3/initPreviewMp3Data.json") as unknown as Promise<
        QRProps<"mp3">
      >
  );

  previewRegistry.register(
    "video",
    VideoTemplate,
    () =>
      import("@/features/previews/templates/video/initPreviewVideoData.json") as unknown as Promise<
        QRProps<"video">
      >
  );

  previewRegistry.register(
    "text",
    TextTemplate,
    () =>
      import("@/features/previews/templates/text/initPreviewTextData.json") as unknown as Promise<
        QRProps<"text">
      >
  );

  previewRegistry.register(
    "social",
    SocialTemplate,
    () =>
      import("@/features/previews/templates/social/initPreviewSocialData.json") as unknown as Promise<
        QRProps<"social">
      >
  );

  previewRegistry.register(
    "sms",
    SmsTemplate,
    () =>
      import("@/features/previews/templates/sms/initPreviewSmsData.json") as unknown as Promise<
        QRProps<"sms">
      >
  );

  previewRegistry.register(
    "event",
    EventTemplate,
    () =>
      import("@/features/previews/templates/event/initPreviewEventData.json") as unknown as Promise<
        QRProps<"event">
      >
  );

  previewRegistry.register(
    "email",
    EmailTemplate,
    () =>
      import("@/features/previews/templates/email/initPreviewEmailData.json") as unknown as Promise<
        QRProps<"email">
      >
  );

  previewRegistry.register(
    "whatsapp",
    WhatsappTemplate,
    () =>
      import("@/features/previews/templates/whatsapp/initPreviewWhatsappData.json") as unknown as Promise<
        QRProps<"whatsapp">
      >
  );

  previewRegistry.register(
    "wifi",
    WifiTemplate,
    () =>
      import("@/features/previews/templates/wifi/initPreviewWifiData.json") as unknown as Promise<
        QRProps<"wifi">
      >
  );
};
